import {
  GET_COMPAY_BONUSES_START,
  GET_COMPAY_BONUSES_SUCCESS,
  GET_COMPAY_BONUSES_FAIL,
  POST_CREATE_COMPANY_START,
  POST_CREATE_COMPANY_SUCCESS,
  POST_CREATE_COMPANY_FAIL,
  DELETE_COMPANY_START,
  DELETE_COMPANY_SUCCESS,
  DELETE_COMPANY_FAIL,
  GET_BRANCHES_BONUSES_START,
  GET_BRANCHES_BONUSES_SUCCESS,
  GET_BRANCHES_BONUSES_FAIL,
  GET_PACKAGES_START,
  GET_PACKAGES_SUCCESS,
  GET_PACKAGES_FAIL,
  CREATE_SERVICE_START,
  CREATE_SERVICE_SUCCESS,
  CREATE_SERVICE_FAIL,
  DELETE_SERVICE_START,
  DELETE_SERVICE_SUCCESS,
  DELETE_SERVICE_FAIL,
  CREATE_CARD_START,
  CREATE_CARD_SUCCESS,
  CREATE_CARD_FAIL,
  UPLOAD_FILE_START,
  UPLOAD_FILE_SUCCESS,
  UPLOAD_FILE_FAIL,
  GET_EVENTS_START,
  GET_EVENTS_SUCCESS,
  GET_EVENTS_FAIL,
  GET_EVENT_START,
  GET_EVENT_SUCCESS,
  GET_EVENT_FAIL,
  GET_TRIGGERS_START,
  GET_TRIGGERS_SUCCESS,
  GET_TRIGGERS_FAIL,
  PATCH_UPDATE_EVENT_START,
  PATCH_UPDATE_EVENT_SUCCESS,
  PATCH_UPDATE_EVENT_FAIL,
  PATCH_SET_ARCHIVED_CARD_START,
  PATCH_SET_ARCHIVED_CARD_SUCCESS,
  PATCH_SET_ARCHIVED_CARD_FAIL,
  GET_CMS_PACKAGES_SUCCESS,
  GET_CMS_PACKAGES_FAIL,
  GET_CMS_PACKAGES_START,
  GET_COPY_EVENT_START,
  GET_COPY_EVENT_SUCCESS,
  GET_COPY_EVENT_FAIL,
  GET_BONUS_RECORDS_START,
  GET_BONUS_RECORDS_SUCCESS,
  GET_BONUS_RECORDS_FAIL,
  GET_BONUS_RECORD_START,
  GET_BONUS_RECORD_SUCCESS,
  GET_BONUS_RECORD_FAIL,
  GET_BONUS_RECORD_HISTORY_START,
  GET_BONUS_RECORD_HISTORY_SUCCESS,
  GET_BONUS_RECORD_HISTORY_FAIL,
  GET_SUBSCRIBERS_LIST_START,
  GET_SUBSCRIBERS_LIST_SUCCESS,
  GET_SUBSCRIBERS_LIST_FAIL,
  DELETE_FILE_FAIL,
  DELETE_FILE_SUCCESS,
  DELETE_FILE_START,
  POST_ON_APPROVE_START,
  POST_ON_APPROVE_SUCCESS,
  POST_ON_APPROVE_FAIL,
  PATCH_APPROVE_START,
  PATCH_APPROVE_SUCCESS,
  PATCH_APPROVE_FAIL,
  GET_BONUSES_PACKAGES_START,
  GET_BONUSES_PACKAGES_SUCCESS,
  GET_BONUSES_PACKAGES_FAIL,
  POST_BONUSES_PACKAGES_START,
  POST_BONUSES_PACKAGES_SUCCESS,
  POST_BONUSES_PACKAGES_FAIL,
  PATCH_BONUSES_PACKAGE_START,
  PATCH_BONUSES_PACKAGE_SUCCESS,
  PATCH_BONUSES_PACKAGE_FAIL,
  PATCH_BONUSES_PACKAGE_STATUS_START,
  PATCH_BONUSES_PACKAGE_STATUS_SUCCESS,
  PATCH_BONUSES_PACKAGE_STATUS_FAIL,
  DELETE_BONUSES_PACKAGE_START,
  DELETE_BONUSES_PACKAGE_SUCCESS,
  DELETE_BONUSES_PACKAGE_FAIL,
  POST_UPLOAD_PACKAGE_IMAGE_START,
  POST_UPLOAD_PACKAGE_IMAGE_SUCCESS,
  POST_UPLOAD_PACKAGE_IMAGE_FAIL,
  GET_BONUS_PACKAGE_START,
  GET_BONUS_PACKAGE_SUCCESS,
  GET_BONUS_PACKAGE_FAIL
} from './constants';
import {
  requestGetCompany,
  requestGetBranches,
  requestGetPackages,
  requestCreateCompany,
  requestDeleteCompany,
  requestCreateService,
  requestDeleteService,
  requestPostCreateEvent,
  requestUploadFiles,
  requestGetEvents,
  requestGetEventById,
  requestGetTriggers,
  requestUpdateEvent,
  requestSetArchviedCard,
  requestGetCmsPackages,
  requestGetCopyBonusCard,
  requestGetBonusRecords,
  requestGetBonusRecordById,
  requestGetBonusRecordHistoryById,
  requestGetSubscribersFile,
  requestDeleteFiles,
  requestUploadFilesForCard,
  requestSendOnApprove,
  requestApproveOrDeny,
  requestGetBonusesPackages,
  requestPostBonusesPackages,
  requestPatchBonusesPackage,
  requestPatchBonusesPackageStatus,
  requestDeleteBonusesPackage,
  requestPostUploadPackageImage,
  requestGetBonusPackage
} from '../../api/bonuses';
import { action } from '../action';
import { TRIGGERS } from '../../features/bonuses/constants';

export const actionsCreateCompany = action(
  POST_CREATE_COMPANY_START,
  POST_CREATE_COMPANY_SUCCESS,
  POST_CREATE_COMPANY_FAIL
);
export const postCreateCompany = (name) => async (dispatch) => {
  try {
    dispatch(actionsCreateCompany.start());
    const data = await requestCreateCompany(name);

    dispatch(actionsCreateCompany.success(data));
  } catch (error) {
    dispatch(actionsCreateCompany.fail(error.detail));
  }
};

export const actionsDeleteCompany = action(
  DELETE_COMPANY_START,
  DELETE_COMPANY_SUCCESS,
  DELETE_COMPANY_FAIL
);
export const deleteCompany = (id) => async (dispatch) => {
  try {
    dispatch(actionsDeleteCompany.start());
    await requestDeleteCompany(id);
    dispatch(actionsDeleteCompany.success(id));
  } catch (error) {
    dispatch(actionsDeleteCompany.fail(error.detail));
  }
};

export const actionsCreateService = action(
  CREATE_SERVICE_START,
  CREATE_SERVICE_SUCCESS,
  CREATE_SERVICE_FAIL
);
export const createService = (payload) => async (dispatch) => {
  try {
    dispatch(actionsCreateService.start());
    const data = await requestCreateService(payload);
    dispatch(actionsCreateService.success(data));
    return data;
  } catch (error) {
    dispatch(actionsCreateService.fail(error.response.data));
  }
};

export const actionsDeleteService = action(
  DELETE_SERVICE_START,
  DELETE_SERVICE_SUCCESS,
  DELETE_SERVICE_FAIL
);
export const deleteService = (id) => async (dispatch) => {
  try {
    dispatch(actionsDeleteService.start());
    const { status } = await requestDeleteService(id);
    dispatch(actionsDeleteService.success({ id, status }));
    return status;
  } catch (error) {
    dispatch(actionsDeleteService.fail(error.detail));
  }
};

export const actionsBonusesPackages = action(
  GET_PACKAGES_START,
  GET_PACKAGES_SUCCESS,
  GET_PACKAGES_FAIL
);
export const getBonusesPackages = (update) => async (dispatch) => {
  try {
    dispatch(actionsBonusesPackages.start());
    const data = await requestGetPackages(update);
    dispatch(actionsBonusesPackages.success(data?.data));
    return data;
  } catch (error) {
    dispatch(actionsBonusesPackages.fail(error.detail));
    return error.response;
  }
};

export const actionsBonusesCompany = action(
  GET_COMPAY_BONUSES_START,
  GET_COMPAY_BONUSES_SUCCESS,
  GET_COMPAY_BONUSES_FAIL
);
export const getBonusesCompany = () => async (dispatch) => {
  try {
    dispatch(actionsBonusesCompany.start());
    const data = await requestGetCompany();
    dispatch(actionsBonusesCompany.success(data));
  } catch (error) {
    dispatch(actionsBonusesCompany.fail(error.detail));
  }
};

export const actionsBonusesBranches = action(
  GET_BRANCHES_BONUSES_START,
  GET_BRANCHES_BONUSES_SUCCESS,
  GET_BRANCHES_BONUSES_FAIL
);
export const getBonusesBranches = (update) => async (dispatch) => {
  try {
    dispatch(actionsBonusesBranches.start());
    const data = await requestGetBranches(update);
    dispatch(actionsBonusesBranches.success(data?.data));
    return data;
  } catch (error) {
    dispatch(actionsBonusesBranches.fail(error.detail));
    return error.response;
  }
};

export const actionsCreateEvent = action(CREATE_CARD_START, CREATE_CARD_SUCCESS, CREATE_CARD_FAIL);
export const postCreateEvent = (payload, moveToNextStep) => async (dispatch) => {
  try {
    dispatch(actionsCreateEvent.start());
    const data = await requestPostCreateEvent(payload);
    dispatch(actionsCreateEvent.success(data));
    moveToNextStep && moveToNextStep();
  } catch (error) {
    dispatch(actionsCreateEvent.fail(error.response?.data));
  }
};

export const actionsUploadFiles = action(UPLOAD_FILE_START, UPLOAD_FILE_SUCCESS, UPLOAD_FILE_FAIL);
export const postUploadFiles = (payload, id) => async (dispatch) => {
  try {
    dispatch(actionsUploadFiles.start());
    let data;
    if (id) data = await requestUploadFilesForCard(payload, id);
    else data = await requestUploadFiles(payload);
    // setFieldValue('sibscribers_files', [...files, data.data.instance]);
    dispatch(actionsUploadFiles.success(data));
    return data;
  } catch (error) {
    dispatch(actionsUploadFiles.fail(error.detail));
    return error.response;
  }
};

export const actionsDeleteFiles = action(DELETE_FILE_START, DELETE_FILE_SUCCESS, DELETE_FILE_FAIL);
export const deleteFiles = (id, file_id) => async (dispatch) => {
  try {
    dispatch(actionsDeleteFiles.start());
    const data = await requestDeleteFiles(id, file_id);
    dispatch(actionsDeleteFiles.success(file_id));
    return data;
  } catch (error) {
    dispatch(actionsDeleteFiles.fail(error.response.data.detail));
    return error.response;
  }
};

export const actionsGetEvents = action(GET_EVENTS_START, GET_EVENTS_SUCCESS, GET_EVENTS_FAIL);
export const getEvents = (payload) => async (dispatch) => {
  try {
    dispatch(actionsGetEvents.start());
    const data = await requestGetEvents(payload);
    dispatch(actionsGetEvents.success(data));
  } catch (error) {
    dispatch(actionsGetEvents.fail(error.detail));
  }
};

export const actionsGetBonusRecords = action(
  GET_BONUS_RECORDS_START,
  GET_BONUS_RECORDS_SUCCESS,
  GET_BONUS_RECORDS_FAIL
);
export const getBonusRecords = (payload) => async (dispatch) => {
  try {
    dispatch(actionsGetBonusRecords.start());
    const data = await requestGetBonusRecords(payload);
    dispatch(actionsGetBonusRecords.success(data));
  } catch (error) {
    dispatch(actionsGetBonusRecords.fail(error.detail));
  }
};

export const actionsGetEvent = action(GET_EVENT_START, GET_EVENT_SUCCESS, GET_EVENT_FAIL);
export const getEventById = (id) => async (dispatch) => {
  try {
    dispatch(actionsGetEvent.start());
    const data = await requestGetEventById(id);
    const foundInputTrigger = TRIGGERS.find((trigger) => trigger.label.match(data.trigger.name));
    if (foundInputTrigger) {
      data.trigger.slug = foundInputTrigger.value;
    }
    dispatch(actionsGetEvent.success(data));
  } catch (error) {
    dispatch(actionsGetEvent.fail(error.detail));
  }
};

export const actionsGetBonusRecordEvent = action(
  GET_BONUS_RECORD_START,
  GET_BONUS_RECORD_SUCCESS,
  GET_BONUS_RECORD_FAIL
);
export const getBonusRecordById = (id) => async (dispatch) => {
  try {
    dispatch(actionsGetBonusRecordEvent.start());
    const data = await requestGetBonusRecordById(id);
    dispatch(actionsGetBonusRecordEvent.success(data));
  } catch (error) {
    dispatch(actionsGetBonusRecordEvent.fail(error.detail));
  }
};

export const actionsGetBonusRecordHistoryEvent = action(
  GET_BONUS_RECORD_HISTORY_START,
  GET_BONUS_RECORD_HISTORY_SUCCESS,
  GET_BONUS_RECORD_HISTORY_FAIL
);
export const getBonusRecordHistoryById = (id) => async (dispatch) => {
  try {
    dispatch(actionsGetBonusRecordHistoryEvent.start());
    const data = await requestGetBonusRecordHistoryById(id);
    dispatch(actionsGetBonusRecordHistoryEvent.success(data));
  } catch (error) {
    dispatch(actionsGetBonusRecordHistoryEvent.fail(error.detail));
  }
};

export const actionsGetCopyEvent = action(
  GET_COPY_EVENT_START,
  GET_COPY_EVENT_SUCCESS,
  GET_COPY_EVENT_FAIL
);
export const getCopyEventById = (id) => async (dispatch) => {
  try {
    dispatch(actionsGetCopyEvent.start());
    const data = await requestGetCopyBonusCard(id);
    const foundInputTrigger = TRIGGERS.find((trigger) => trigger.label.match(data.trigger.name));
    if (foundInputTrigger) {
      data.trigger.slug = foundInputTrigger.value;
    }
    dispatch(actionsGetCopyEvent.success(data));
  } catch (error) {
    dispatch(actionsGetCopyEvent.fail(error.detail));
  }
};

export const actionsGetTriggers = action(
  GET_TRIGGERS_START,
  GET_TRIGGERS_SUCCESS,
  GET_TRIGGERS_FAIL
);
export const getTriggers = () => async (dispatch) => {
  try {
    dispatch(actionsGetTriggers.start());
    const data = await requestGetTriggers();
    const extendedData = extendTriggers(data);
    dispatch(actionsGetTriggers.success(extendedData));
  } catch (error) {
    dispatch(actionsGetTriggers.fail(error.detail));
  }
};

const extendTriggers = (data) => {
  TRIGGERS.forEach((trigger) => {
    const foundInputTrigger = data.find((inputTrigger) => inputTrigger.name.match(trigger.label));

    if (foundInputTrigger) {
      data[data.indexOf(foundInputTrigger)].slug = trigger.value;
    }
  });

  return data;
};

export const actionsUpdateEvents = action(
  PATCH_UPDATE_EVENT_START,
  PATCH_UPDATE_EVENT_SUCCESS,
  PATCH_UPDATE_EVENT_FAIL
);
export const updateEvent = (id, payload) => async (dispatch) => {
  try {
    dispatch(actionsUpdateEvents.start());
    const data = await requestUpdateEvent(id, payload);
    dispatch(actionsUpdateEvents.success(data));
    return data;
  } catch (error) {
    dispatch(actionsUpdateEvents.fail(error.response.data));
  }
};

export const actionsArchivedCard = action(
  PATCH_SET_ARCHIVED_CARD_START,
  PATCH_SET_ARCHIVED_CARD_SUCCESS,
  PATCH_SET_ARCHIVED_CARD_FAIL
);
export const archivedCard = (id, redirectToBonuses) => async (dispatch) => {
  try {
    dispatch(actionsArchivedCard.start());
    const data = await requestSetArchviedCard(id, { status: 'Архив' });
    const dataWithID = { ...data, id: id };
    dispatch(actionsArchivedCard.success(dataWithID));
    redirectToBonuses && redirectToBonuses();
  } catch (error) {
    dispatch(actionsArchivedCard.fail(error.detail));
  }
};

export const actionsGetCmsPackages = action(
  GET_CMS_PACKAGES_START,
  GET_CMS_PACKAGES_SUCCESS,
  GET_CMS_PACKAGES_FAIL
);
export const getCmsPackages = (payload) => async (dispatch) => {
  try {
    dispatch(actionsGetCmsPackages.start());
    const data = await requestGetCmsPackages(payload);
    const transformedData = data.data.map((item) => ({
      id: item.id,
      name: item.name,
      image: item.data.package_details
    }));
    dispatch(actionsGetCmsPackages.success(transformedData));
    return data;
  } catch (error) {
    dispatch(actionsGetCmsPackages.fail(error.detail));
    return error.response;
  }
};

export const actionsGetSubscribersList = action(
  GET_SUBSCRIBERS_LIST_START,
  GET_SUBSCRIBERS_LIST_SUCCESS,
  GET_SUBSCRIBERS_LIST_FAIL
);
export const getSubscribersList = (id, payload) => async (dispatch) => {
  try {
    dispatch(actionsGetSubscribersList.start());
    const data = await requestGetSubscribersFile(id, payload);
    dispatch(actionsGetSubscribersList.success(data));
  } catch (error) {
    dispatch(actionsGetSubscribersList.fail(error.detail));
  }
};

export const actionsOnApproveCard = action(
  POST_ON_APPROVE_START,
  POST_ON_APPROVE_SUCCESS,
  POST_ON_APPROVE_FAIL
);
export const onApproveCard = (id) => async (dispatch) => {
  try {
    dispatch(actionsOnApproveCard.start());
    const data = await requestSendOnApprove(id);
    const dataWithID = { ...data, id: id };
    dispatch(actionsOnApproveCard.success(dataWithID));
  } catch (error) {
    dispatch(actionsOnApproveCard.fail(error.detail));
  }
};

export const actionsApproveCard = action(
  PATCH_APPROVE_START,
  PATCH_APPROVE_SUCCESS,
  PATCH_APPROVE_FAIL
);
export const approveCard = (id, payload) => async (dispatch) => {
  try {
    dispatch(actionsApproveCard.start());
    const data = await requestApproveOrDeny(id, payload);
    const dataWithID = { ...data, id: id, status: payload.status, reason: payload.reason };
    dispatch(actionsApproveCard.success(dataWithID));
  } catch (error) {
    dispatch(actionsApproveCard.fail(error.detail));
  }
};

export const actionsGetBonusesPackages = action(
  GET_BONUSES_PACKAGES_START,
  GET_BONUSES_PACKAGES_SUCCESS,
  GET_BONUSES_PACKAGES_FAIL
);
export const getPackages = (payload) => async (dispatch) => {
  try {
    dispatch(actionsGetBonusesPackages.start());
    const data = await requestGetBonusesPackages(payload);
    dispatch(actionsGetBonusesPackages.success(data));
  } catch (error) {
    dispatch(actionsGetBonusesPackages.fail(error.detail));
  }
};
export const actionsGetBonusPackage = action(
  GET_BONUS_PACKAGE_START,
  GET_BONUS_PACKAGE_SUCCESS,
  GET_BONUS_PACKAGE_FAIL
);
export const getPackage = (payload) => async (dispatch) => {
  try {
    dispatch(actionsGetBonusPackage.start());
    const data = await requestGetBonusPackage(payload);
    dispatch(actionsGetBonusPackage.success(data));
  } catch (error) {
    dispatch(actionsGetBonusPackage.fail(error.detail));
  }
};

export const actionsPostBonusesPackages = action(
  POST_BONUSES_PACKAGES_START,
  POST_BONUSES_PACKAGES_SUCCESS,
  POST_BONUSES_PACKAGES_FAIL
);
export const postPackages = (payload) => async (dispatch) => {
  try {
    dispatch(actionsPostBonusesPackages.start());
    const data = await requestPostBonusesPackages(payload);
    dispatch(actionsPostBonusesPackages.success(data));
  } catch (error) {
    dispatch(actionsPostBonusesPackages.fail(error.response.data));
    throw new Error(error.response.data.message)
  }
};

export const actionsPatchBonusesPackage = action(
  PATCH_BONUSES_PACKAGE_START,
  PATCH_BONUSES_PACKAGE_SUCCESS,
  PATCH_BONUSES_PACKAGE_FAIL
);
export const patchPackage = (id, payload) => async (dispatch) => {
  try {
    dispatch(actionsPatchBonusesPackage.start());
    const data = await requestPatchBonusesPackage(id, payload);
    dispatch(actionsPatchBonusesPackage.success(data));
  } catch (error) {
    dispatch(actionsPatchBonusesPackage.fail(error.response.data));
    throw new Error(error.response.data.message)
  }
};

export const actionsPatchBonusesPackageStatus = action(
  PATCH_BONUSES_PACKAGE_STATUS_START,
  PATCH_BONUSES_PACKAGE_STATUS_SUCCESS,
  PATCH_BONUSES_PACKAGE_STATUS_FAIL
);
export const patchPackageStatus = (id, payload) => async (dispatch) => {
  try {
    dispatch(actionsPatchBonusesPackageStatus.start());
    await requestPatchBonusesPackageStatus(id, payload);
    dispatch(actionsPatchBonusesPackageStatus.success({ id, status: payload.status }));
  } catch (error) {
    dispatch(actionsPatchBonusesPackageStatus.fail(error.detail));
  }
};

export const actionsDeleteBonusesPackage = action(
  DELETE_BONUSES_PACKAGE_START,
  DELETE_BONUSES_PACKAGE_SUCCESS,
  DELETE_BONUSES_PACKAGE_FAIL
);
export const deletePackage = (id) => async (dispatch) => {
  try {
    dispatch(actionsDeleteBonusesPackage.start());
    await requestDeleteBonusesPackage(id);
    dispatch(actionsDeleteBonusesPackage.success(id));
  } catch (error) {
    dispatch(actionsDeleteBonusesPackage.fail(error.detail));
  }
};

export const actionsPostUploadPackageImage = action(
  POST_UPLOAD_PACKAGE_IMAGE_START,
  POST_UPLOAD_PACKAGE_IMAGE_SUCCESS,
  POST_UPLOAD_PACKAGE_IMAGE_FAIL
);
const UPLOAD_ERROR_BY_STATUS = {
  413: 'Файл слишком большой',
  415: 'Неподдерживаемый формат файла'
};

// cms-loyalty returns errors as { message }, older services as { detail }.
// 413 may come from the ingress with an HTML body, so status is checked first.
const getUploadErrorMessage = (error) => {
  const { status, data } = error?.response ?? {};
  return UPLOAD_ERROR_BY_STATUS[status]
    || data?.message
    || data?.detail
    || 'Не удалось загрузить файл';
};

export const uploadPackageImage = (file) => async (dispatch) => {
  try {
    dispatch(actionsPostUploadPackageImage.start());
    const data = await requestPostUploadPackageImage(file);
    dispatch(actionsPostUploadPackageImage.success(data));

    return data
  } catch (error) {
    const message = getUploadErrorMessage(error);
    dispatch(actionsPostUploadPackageImage.fail(message));
    throw new Error(message);
  }
};
